/*
*当前运行环境
正式环境有两个域名www.xfplink.cn和www.kaifapiao.com(支持https)
演示环境toc.e-fp.cn
测试环境www.e-fp.cn
本地环境localhost---TEST接口
 */
//获取当前页面访问路径--->确定环境ENV--->通过各个环境MAP获取相应的环境参数
const URL = window.location.origin
  ? window.location.origin
  : `${window.location.protocol}//${window.location.hostname}`;
const ENV = [
  { host: /kaifapiao\./, env: 'PROD' },
  { host: /xfplink\./, env: 'PROD' },
  { host: /toc\./, env: 'DEMO' },
  { host: /.*/, env: 'TEST' },
].find(item => item.host.test(URL)).env;
const API_KEY_MAP = {
  DEMO: 'YoO45SINRHiOCISOfn3olA0bBvxCPsPf55CwX6FhAbTYM6nhFOa7jDqhMTu8LboKNLT3lD7i038%3D',
  TEST: 'YoO45SINRHiOCISOfn3olA0bBvxCPsPf55CwX6FhAbTYM6nhFOa7jDqhMTu8LboKNLT3lD7i038%3D',
  PROD:
    'YoO45SINRHg8tSKMzuVt7ddjchTinZ%2BrJ3GY1vBH6XX%2FEJRYwVfcpxPPeBlhzspj%2B2njPK3vKwFn%0AZfCcJXQy2gnwwZJEVsiVVL%2F%2FWYcA5J8%3D',
};
const WECHAT_APPID_MAP = {
  DEMO: 'wx11ba3047eaafe738',
  TEST: 'wxe78e1e22709d38ef',
  PROD: 'wxa162fb6b362c3016',
};
const API_ROOT_MAP = {
  DEMO: URL,
  TEST: 'http://www.e-fp.cn',
  // TEST: 'http://47.96.240.238',
  PROD: URL,
};
const API_HTTP_MAP = {
  DEMO: URL,
  TEST: 'http://www.e-fp.cn',
  PROD: 'https://www.xfplink.cn',
};
const API_OWT_MAP = {
  DEMO: 'https://ow-t.xforceplus.com',
  TEST: 'http://ow-t.xforceplus.com:8013',
  PROD: 'https://ow.xforceplus.com',
};
var cfg = {
  URL,
  envType: ENV,
  //是否是调试模式
  debug: true,
  //是否要模拟登陆  需要服务APi支持，暂不启用
  autoLogin: false,
  //模拟登陆   账号
  autoLoginInfo: {
    source: '',
    openId: '',
    otId: '',
    userId: '',
  },
  //api请求地址
  api: {
    /**http地址 api 用于微信跳转（微信有时候只认xfplink为合法，正式微信跳转xfplink） */
    LOCATION_ORIGIN: API_HTTP_MAP[ENV],
    /**销项服务api前缀 */
    SALES_API_ROOT: '/sales-api',
    /**进项服务api前缀 */
    PURCHASE_API_ROOT: '/purchase-api',
    /**开发者ID(AppID) */
    wechat_appId: WECHAT_APPID_MAP[ENV],
    /**默认用户token */
    api_key: API_KEY_MAP[ENV],
    /**集成服务 api */
    api_owt: API_OWT_MAP[ENV],
  },
};
export default cfg;
